import { render, staticRenderFns } from "./report.vue?vue&type=template&id=2dd99c10&scoped=true&"
import script from "./report.js?vue&type=script&lang=js&"
export * from "./report.js?vue&type=script&lang=js&"
import style0 from "./report.vue?vue&type=style&index=0&id=2dd99c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd99c10",
  null
  
)

export default component.exports